// extracted by mini-css-extract-plugin
export default {"toggle":"attachmentDropdown_toggle__XgXuu","menu":"attachmentDropdown_menu__IYUXw","optionButton":"attachmentDropdown_optionButton__5R1jr"};